/**
 * 통계 차트 관련 js 전부 여기에 있습니다.
 */

const dataColorArr = ['#4aa7fb', '#ffe164', '#ff8b7a', '#fcbd6a', '#d8aaff', '#7a9bfd', '#98abd6', '#46d6bf', '#3880f1', '#ffbd2c', '#ff6367', '#f99043', '#be72ff', '#626ffc', '#6079b2', '#00ba8f'];


// 배열 안 모든 값 합산
function sumArr(arr) {
  let arrSum = 0;
  for(let s=0; s<arr.length; s++) {
    arrSum += arr[s];
  }
  return arrSum;
}
function getPercentage(thisData, totalData) {
  let total = totalData.replace(/,/g, "");
  let result = (parseInt(thisData) / parseInt(total)) * 100;
  result = result.toFixed(1)
  return result
}

function getPosition(arr, index) {
  let preval = 0;
  let val = 0;
  for(let p=0; p<=index; p++) {
    val += arr[p];
    if(p>0) {
      preval += arr[p-1];
    } else {
      preval = 0;
    }
  }
  let position = val/sumArr(arr);
  let preposition = preval/sumArr(arr);
  let avg = (position + preposition) / 2
  return avg;
}

function getPadding(labelArr, dataArr) {
  let chartPadding = {top:0, bottom:0, left:0, right:0};
  if(getBreakpoint() == 'lg') {
    let outdataIndex = [];
    for(let i=0; i<dataArr.length; i++) {
      let percent = getPercentage(dataArr[i], sumArr(dataArr).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      let labelLen = labelArr[i].length;
      if(percent <= 8 || labelLen>6) {
        outdataIndex.push(i);
      }
    }
    let topTime = 0;
    let bottomTime = 0;
    for(let i=0; i<outdataIndex.length; i++) {
      let position = getPosition(dataArr, outdataIndex[i]);
      if(position>=0 && position<=0.1) {
        $('.chart-container').removeClass('has-padding');
        topTime += 1;
        chartPadding.top = 50*topTime;
  
      } else if(position>=0.9 && position<=1) {
        $('.chart-container').removeClass('has-padding');
        topTime += 1;
        chartPadding.top = 50*topTime;
  
      } else if(position>=0.4 && position<=0.6) {
        $('.chart-container').removeClass('has-padding');
        bottomTime += 1;
        chartPadding.bottom = 50*bottomTime;
      }
    }
    let bottom = chartPadding.bottom / 2
    let top = chartPadding.top / 2;
    if(chartPadding.top > 0) {
      $('.chart-wrap .doughnut-inner').css('top', `calc(50% + ${top}px)`);
    }
    if(chartPadding.bottom > 0) {
      $('.chart-wrap .doughnut-inner').css('top', `calc(50% - ${bottom}px)`);
      if(chartPadding.top > 0) {
        $('.chart-wrap .doughnut-inner').css('top', `calc(50% - ${bottom - top}px)`);
      }
    }
  } else if(getBreakpoint() == 'md') {
    chartPadding.bottom = 0;
    $('.chart-wrap .doughnut-inner').css('top', `50%`);
  } else {
    chartPadding.bottom = 60;
    $('.chart-wrap .doughnut-inner').css('top', `calc(50% - 30px)`);
  }
  return chartPadding
}

function getBreakpoint() {
  let breakpoint = getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content');
  breakpoint = breakpoint.replaceAll('"', '');
  return breakpoint;
};

function changeChartBar(chartID, chartData) {
  $('.chart-container').addClass('has-padding');
  $('.chart-container h5').text(chartData.dataTitle);
  // draws a rectangle with a rounded top
  roundedBar();

  // 이전꺼 지우고 다시 넣기
  const $parent = $(`#${chartID}`).parents('.chart-wrap');
  $parent.empty();
  $parent.prepend(`<canvas id="${chartID}"></canvas>`);

  //var ctx = document.getElementById(chartID);

  const myChart = new Chart(chartID, {
    plugins: [ChartDataLabels],
    type: 'bar',
    data: {
      labels: chartData.labelArr,
      datasets: [
        {
          data: chartData.dataArr,
          backgroundColor: dataColorArr,
          datalabels: { anchor: 'end', align: 'end' }
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      barRoundness: 0.5,
      legend: {
        display: false,
      },
      layout: {
        padding: {
          top: 30
        },
      },
      scales: {
        yAxes: [{
          gridLines: {
            //display: false
            drawOnChartArea: false,
            //drawTicks: false,
            //tickMarkLength: 10
            borderDashOffset: false
          },
          ticks: {
            beginAtZero: true,
            fontColor: "#434e5a",
          }
        }],
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          },
          ticks: {
            fontColor: "#434e5a",
          },
          barPercentage: 0.5, // bar가 차지하는 가로 폭의 비율
          categoryPercentage: 0.5 // label의 bar 사이의 간격 비율
        }],
      },
      plugins: {
        datalabels: {
          color: '#49525d',
          display: true,
          font: {
            size: 14,
            weight: '500',
          },
        },
      }
    }
  });
}
function changeChartPie(chartID, chartData) {
  $('.chart-container').addClass('has-padding');
  $('.chart-container h5').text(chartData.dataTitle);
  // 이전꺼 지우고 다시 넣기
  const $parent = $(`#${chartID}`).parents('.chart-wrap');
  $parent.empty();
  $parent.prepend(`<canvas id="${chartID}"></canvas>`);
  let dataTotal = sumArr(chartData.dataArr);
  dataTotal = dataTotal.toLocaleString('en-US');

  $parent.prepend(`<div class="doughnut-inner">
    <div class="data-total">${dataTotal}</div>
  </div>`);

  let windowWidth = window.outerWidth;

  const myChart = new Chart(chartID, {
    type: 'doughnut',
    data: {
      labels: chartData.labelArr,
      datasets: [
        {
          borderWidth: 0,
          data: chartData.dataArr,
          backgroundColor: dataColorArr,
        },
      ],
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      cutoutPercentage: 48,
      layout: {
        padding: getPadding(chartData.labelArr, chartData.dataArr),
      },
      pieceLabel: {
        mode: 'label',
        position: 'default',
        fontSize: 14,
        fontStyle: 500,
        overlap: true,
        fontColor: '#1e252d',
        render: function (args) {
          if (getPercentage(args.value, dataTotal) > 8) {
            if(args.label.length > 6) {
              return getPercentage(args.value, dataTotal) + '%';
            } else {
              let newLabel = args.label + '\n' + getPercentage(args.value, dataTotal) + '%';
              return newLabel;
            }
          } else {
            return '';
          }
        },
      },
      plugins: {
        legend: false,
        outlabels: {
          //text: '%l \n %p',
          text: function (context) {
            let index = context.dataIndex;
            let label = context.labels[index];
            if (getBreakpoint() == 'lg') {
                if (label.length > 18) {
                  label = label.substring(0, 20) + '···';
                }
              } else {
                if (label.length > 12) {
                  label = label.substring(0, 14) + '···';
                }
              }
            //label = label.substring(0, 14) + '···';
  
            let newLabel = `${label} \n ${context.percent.toFixed(2)}%`;
            return newLabel;
          },
          stretch: 20,
          color: '#000000',
          display: function (context) {
            let index = context.dataIndex;
            let label = context.labels[index];
            if (getBreakpoint() == 'lg') {
              if(context.percent < 0.08) {
                return true;
              } else {
                if (label.length <= 6) {
                  return false;
                }
                return true;
              }
            } else {
              return false;
            }
          },
          font: {
            resizable: true,
            minSize: 12,
            maxSize: 12,
          },
        },
      },
      onResize: function () {
        myChart.options.layout.padding = getPadding(chartData.labelArr, chartData.dataArr);
        myChart.update();
      },
    }
  });

}
function changeChartLine(chartID, chartLabels, dataTitle, chartData) {
  $('.chart-container').addClass('has-padding');
  $('.chart-container h5').text(dataTitle);
  // 이전꺼 지우고 다시 넣기
  const $parent = $(`#${chartID}`).parents('.chart-wrap');
  $parent.empty();
  $parent.prepend(`<canvas id="${chartID}"></canvas>`);

  let datasetArr = [];
  let dataInner = {};
  for(let i=0; i<chartData.length; i++) {
    dataInner = {
      label: chartData[i].label,
      data: chartData[i].dataArr,
      borderColor: dataColorArr[i],
      fill: false,
    }
    datasetArr.push(dataInner);
  }

  
  const myChart = new Chart(chartID, {
    type: 'line',
    data: {
      labels: chartLabels,
      datasets: datasetArr,
    },
    options: {
      maintainAspectRatio: false,
      responsive: true,
      scales: {
        yAxes: [{
          gridLines: {
            //display: false
            drawOnChartArea: false,
            //drawTicks: false,
            //tickMarkLength: 10
            borderDashOffset: false
          },
          ticks: {
            borderDashOffset: false,
            beginAtZero: true,
            sampleSize: 50,
            //max: 400,
            fontColor: "#434e5a",
          }
        }],
      },
      onResize: function () {
        //myChart.options.layout.padding = getPadding();
        myChart.update();
      },
      plugins: {
        legend: false,
        labels: false,
      },
    }
  });

}